import cn from './zh-cn';
import en from './en-us';
import { SERVER_LANG } from 'config/variable';
// 语言包映射
let langMap = {
  cn,
  en
};
// 返回语言函数
export default function lang(text) {
  if (SERVER_LANG === 'cn') {
    return text;
  }
  return langMap[SERVER_LANG][text] ? langMap[SERVER_LANG][text] : text;
}
